/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PatientAddressEdit.vue?vue&type=template&id=be9a728c"
import script from "./PatientAddressEdit.vue?vue&type=script&lang=js"
export * from "./PatientAddressEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be9a728c')) {
      api.createRecord('be9a728c', component.options)
    } else {
      api.reload('be9a728c', component.options)
    }
    module.hot.accept("./PatientAddressEdit.vue?vue&type=template&id=be9a728c", function () {
      api.rerender('be9a728c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/PatientAddressEdit.vue"
export default component.exports